import React from "react";
import AssessmentPreparation from "Views/InterviewCandidates/Docs/AssessmentPreparation";

const QAAssessmentPreparation = () => {
    return <AssessmentPreparation assessmentName='QA Assessment' />;
};

export default QAAssessmentPreparation;
